import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import PartnerEarnings from "@/pages/PartnerEarnings";
import OperatorConsole from "@/pages/OperatorConsole";
import TradeHistory from "@/pages/TradeHistory";
import TelegramFloat from "@/components/marketing/TelegramFloat";
import { ConfigProvider } from "@/hooks/useConfig";
import { AuthProvider } from "@/hooks/useAuth";
import ErrorBoundary from "@/components/ErrorBoundary";
import useVersionGuard from "@/hooks/useVersionGuard";
import { captureAdSrc } from "@/lib/adtrack";
import { recordAdSrc } from "@/lib/adtrack";
import HelpBot from "@/components/HelpBot";

// 🔗 Short memorable entry (/tiktok, /tg...) — records the ad source then
// lands on the homepage. For bios/comments where ?src= links look ugly.
const ShortLink = ({ tag }) => {
  useEffect(() => recordAdSrc(tag), [tag]);
  return <Navigate to="/" replace />;
};

// Capture ?ref=<code> on ANY entry route (landing, /trade, shared links) so the
// referral survives the OAuth round-trip; bound to the account after login.
const _ref = new URLSearchParams(window.location.search).get("ref");
if (_ref) localStorage.setItem("vts_ref_code", _ref);
// 📈 Capture ?src=<ad tag> the same way (paid-ads attribution).
captureAdSrc();

function App() {
  useVersionGuard(); // 🔄 auto-refresh phones stuck on an old cached build
  return (
    <div className="App">
      <ErrorBoundary>
      <ConfigProvider>
        <AuthProvider>
          <BrowserRouter>
            <HelpBot />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/tiktok" element={<ShortLink tag="tiktok_bio" />} />
              <Route path="/tg" element={<ShortLink tag="tg_bio" />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/trade" element={<Dashboard />} />
              <Route path="/history" element={<TradeHistory />} />
              <Route path="/partner" element={<PartnerEarnings />} />
              <Route path="/operator" element={<OperatorConsole />} />
              <Route path="*" element={<Landing />} />
            </Routes>
            <TelegramFloat />
          </BrowserRouter>
          <Toaster theme="dark" position="top-center" richColors expand={true} closeButton />
        </AuthProvider>
      </ConfigProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
